import Curriculum from '../../content/curriculum';
import { CONTENT_VERSION } from '../../data/constants';

const curriculum = Curriculum[CONTENT_VERSION];

export const selectCurrentScene = (currentLevelIndex, currentSceneIndex) => (
  curriculum.levels[currentLevelIndex].scenes[currentSceneIndex]
);
export const selectCurrentObject = (currentLevelIndex, currentSceneIndex, currentObjectIndex) => (
  selectCurrentScene(currentLevelIndex, currentSceneIndex).objects[currentObjectIndex]
);
export const selectNumScenesInLevel = currentLevelIndex => (
  curriculum.levels[currentLevelIndex].scenes.length
);
export const selectNumQuestionItemsInScene = (currentLevelIndex, currentSceneIndex) => (
  selectCurrentScene(currentLevelIndex, currentSceneIndex).objects.length
);
export const selectInitialSceneAItems = (currentLevelIndex, currentSceneIndex) => (
  selectCurrentScene(currentLevelIndex, currentSceneIndex).sceneAItems
);
export const selectInitialSceneBItems = (currentLevelIndex, currentSceneIndex) => (
  selectCurrentScene(currentLevelIndex, currentSceneIndex).sceneBItems
);
export const selectLevelCount = () => curriculum.levels.length;
